import { c as _c } from "react/compiler-runtime";
import { TourResultMessageSchema } from "@website/accommodation-ui/tour-result-messages/schema";
import { TourResultMessagesPropertiesType } from "@website/accommodation-ui/tour-result-messages/types";
import { MaterialIcon } from "@website/icons/material";
import { LazyImage } from "@website/ui/lazy-image";
import { Loading } from "@website/ui/loading";
import Link from "next/link";
import { FC } from "react";
export const TourResultMessages: FC<TourResultMessagesPropertiesType> = properties => {
  const $ = _c(23);
  const {
    type,
    link,
    origin,
    destination
  } = properties;
  const {
    message,
    image,
    caption,
    continueCaption1,
    buttonTitle,
    buttonIcon
  } = TourResultMessageSchema[type];
  let t0;
  if ($[0] !== image || $[1] !== message) {
    t0 = <LazyImage alt={message} loading="eager" src={image} />;
    $[0] = image;
    $[1] = message;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = type === "LOADING" ? `${origin} به
          ${destination} ...` : "";
  let t2;
  if ($[3] !== message || $[4] !== t1) {
    t2 = <div className="text-subtitle-1 text-on-surface-high-emphasis">{message}{" "}{t1}</div>;
    $[3] = message;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = continueCaption1 ? ` " ${origin} -
          ${destination} " ${continueCaption1}` : "";
  let t4;
  if ($[6] !== caption || $[7] !== t3) {
    t4 = <div className="text-caption text-on-surface-medium-emphasis text-center">{caption}{t3}</div>;
    $[6] = caption;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== type) {
    t5 = type === "LOADING" && <div className="mt-6"><Loading color="primary" size="lg" /></div>;
    $[9] = type;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex flex-col items-center gap-2">{t2}{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== buttonIcon || $[16] !== buttonTitle || $[17] !== link) {
    t7 = buttonTitle && link && buttonIcon && <Link className="text-button border-secondary fill-secondary text-secondary hover:bg-states-secondary-hover active:bg-states-secondary-pressed inline-flex h-10 items-center justify-center gap-2 rounded-lg border px-3 py-2" href={link}><MaterialIcon className="size-[18px] text-lg leading-[18px]" name={buttonIcon} /><span>{buttonTitle}</span></Link>;
    $[15] = buttonIcon;
    $[16] = buttonTitle;
    $[17] = link;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t0 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="flex w-[312px] flex-col items-center gap-6 place-self-center py-4">{t0}{t6}{t7}</div>;
    $[19] = t0;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};